module.exports = "\n\t\t\t\t<div class = 'embed.container'\n\t\t*ngIf=\"work.vimeoID\">\n  <div [innerHtml]=\"vimeoEmbedString\"></div>\n</div>"